import { getApiClient } from './authApiClient';

export const getAllTenants = async () => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get('/tenants/fetchall');
    return response.data;
  } catch (error) {
    console.error('Error fetching tenants:', error);
    throw error;
  }
};

export const createTenant = async (tenantData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/tenants/create', tenantData);
    return response.data;
  } catch (error) {
    console.error('Error creating tenant:', error);
    throw error;
  }
};

export const getTenantById = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/tenants/fetch/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tenant by ID:', error);
    throw error;
  }
};

export const updateTenant = async (tenantId, tenantData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/tenants/update/${tenantId}`, tenantData);
    return response.data;
  } catch (error) {
    console.error('Error updating tenant:', error);
    throw error;
  }
};

export const deleteTenant = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/tenants/delete/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting tenant:', error);
    throw error;
  }
};

// ==================== DASHBOARD PREFERENCES OPERATIONS ====================

// Create a new dashboard preference
export const createDashboardPreferences = async (data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/dashboard-preferences/create', data);
    return response.data;
  } catch (error) {
    console.error('Error creating dashboard preference:', error);
    throw error;
  }
};

// Get preferences by tenant ID
export const getPreferencesByTenantId = async (tenantId) => {
  console.log("🚀 ~ getPreferencesByTenantId ~ tenantId:", tenantId)
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/dashboard-preferences/fetchbytenant/${tenantId}`);
    console.log("🚀 ~ getPreferencesByTenantId ~ response:", response)
    return response.data;
  } catch (error) {
    console.error('Error fetching preferences by tenant ID:', error);
    throw error;
  }
};

// Update preferences by ID
export const updatePreferences = async (id, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/dashboard-preferences/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating preferences by ID:', error);
    throw error;
  }
};

// Delete preference by ID
export const deletePreferences = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/dashboard-preferences/delete/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting preferences:', error);
    throw error;
  }
};

// Get preferences by tenant ID and feature
export const getPreferencesByTenantIdAndFeature = async (tenantId, feature) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/dashboard-preferences/fetchbytenantandfeature/${tenantId}/${feature}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching preferences by tenant ID and feature:', error);
    throw error;
  }
};

// Delete all preferences for a tenant by tenant ID
export const deleteDashboardPreferencesByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/dashboard-preferences/deletebytenant/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting preferences by tenant ID:', error);
    throw error;
  }
};

// Update all preferences for a tenant by tenant ID & feature
export const updateDashboardPreferencesByTenantIdAndFeature = async (tenantId, feature, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(
      `/dashboard-preferences/updatebytenantandfeature/${tenantId}/${feature}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error updating preferences by tenant ID and feature:', error);
    throw error;
  }
};

// ==================== USER PREFERENCES OPERATIONS ====================

// Create a new user preference
export const createUserPreferences = async (data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/dashboard-preferences/user-preferences/create', data);
    return response.data;
  } catch (error) {
    console.error('Error creating user preference:', error);
    // Dummy response for when backend doesn't exist yet
    // if (error.response?.status === 404) {
    //   console.log('User preferences endpoint not found, using dummy response');
    //   return { data: { id: 'dummy-id', ...data } };
    // }
    throw error;
  }
};

// Get user preferences by user ID
export const getUserPreferencesByUserId = async (userId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/dashboard-preferences/user-preferences/fetchbyuser/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user preferences by user ID:', error);
    // Dummy response for when backend doesn't exist yet
    if (error.response?.status === 404) {
      console.log('User preferences endpoint not found, using dummy response');
      return [];
    }
    throw error;
  }
};

// Get user preferences by user ID and feature
export const getUserPreferencesByUserIdAndFeature = async (userId, feature) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/dashboard-preferences/user-preferences/fetchbyuserandfeature/${userId}/${feature}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching user preferences by user ID and feature:', error);
    // Dummy response for when backend doesn't exist yet
    if (error.response?.status === 404) {
      console.log('User preferences endpoint not found, using dummy response');
      return null;
    }
    throw error;
  }
};

// Update user preferences by user ID and feature
export const updateUserPreferencesByUserIdAndFeature = async (userId, feature, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(
      `/dashboard-preferences/user-preferences/updatebyuserandfeature/${userId}/${feature}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user preferences by user ID and feature:', error);
    // Dummy response for when backend doesn't exist yet
    // if (error.response?.status === 404) {
    //   console.log('User preferences endpoint not found, using dummy response');
    //   return { data: { id: 'dummy-id', userId, feature, ...data } };
    // }
    throw error;
  }
};

// Delete user preferences by user ID
export const deleteUserPreferencesByUserId = async (userId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/dashboard-preferences/user-preferences/deletebyuser/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting user preferences by user ID:', error);
    // Dummy response for when backend doesn't exist yet
    if (error.response?.status === 404) {
      console.log('User preferences endpoint not found, using dummy response');
      return { success: true };
    }
    throw error;
  }
};

// ==================== CUSTOM PROMPTS OPERATIONS ====================

// Create a new custom prompt
export const createCustomPrompt = async (data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/custom-prompts/create', data);
    return response.data;
  } catch (error) {
    console.error('Error creating custom prompt:', error);
    throw error;
  }
};

// Get a custom prompt by tenant ID
export const getCustomPromptByTenantId = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/custom-prompts/by-tenant/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching custom prompt by tenant ID:', error);
    throw error;
  }
};

// Update all custom prompts by tenant ID
export const updateAllCustomPromptsByTenant = async (tenantId, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(
      `/custom-prompts/by-tenant-update/${tenantId}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Error updating all custom prompts by tenant ID:', error);
    throw error;
  }
};

// Update a custom prompt by tenant ID and segment ID
export const updateCustomPromptByTenantAndSegment = async (tenantId, segmentId, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(
      `/custom-prompts/updatebytenantandsegmentid/${tenantId}/${segmentId}`, data
    );
    return response.data;
  } catch (error) {
    console.error('Error updating custom prompt by tenant ID and segment ID:', error);
    throw error;
  }
};

// Update a custom prompt by ID
export const updateCustomPromptById = async (id, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/custom-prompts/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating custom prompt by ID:', error);
    throw error;
  }
};

// Delete a custom prompt by tenant ID
export const deleteCustomPromptByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/custom-prompts/delete/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting custom prompt by tenant ID:', error);
    throw error;
  }
};

// Delete all custom prompts for a tenant
export const deleteAllCustomPromptsByTenant = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/custom-prompts/deletebytenant/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting all custom prompts by tenant ID:', error);
    throw error;
  }
};

// Delete custom prompt using tenantID and segment Id
export const deleteCustomPromptsByTenantAndSegment = async (tenantId, segmentId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/custom-prompts/by-tenant-segment-delete/${tenantId}/${segmentId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting custom prompts by tenant ID and segment ID:', error);
    throw error;
  }
};

// ==================== SEGMENT OPERATIONS ====================

// Create a new segment
export const createSegment = async (data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/segment/create', data);
    return response.data;
  } catch (error) {
    console.error('Error creating segment:', error);
    throw error;
  }
};

// Get all segments
export const getAllSegments = async () => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get('/segment/fetchall');
    return response.data;
  } catch (error) {
    console.error('Error fetching all segments:', error);
    throw error;
  }
};

// Get segments by tenant ID
export const getSegmentsByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/segment/by-tenant/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching segments by tenant ID:', error);
    throw error;
  }
};

// Update segments by tenant ID
export const updateSegmentsByTenantId = async (tenantId, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/segment/by-tenant-update/${tenantId}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating segments by tenant ID:', error);
    throw error;
  }
};

// Delete segments by tenant ID
export const deleteSegmentsByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/segment/by-tenant-delete/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting segments by tenant ID:', error);
    throw error;
  }
};

// Get a single segment by ID
export const getSegmentById = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/segment/fetch/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching segment by ID:', error);
    throw error;
  }
};

// Update a segment by ID
export const updateSegment = async (id, data) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/segment/update/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating segment by ID:', error);
    throw error;
  }
};

// Delete a segment by ID
export const deleteSegment = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/segment/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting segment by ID:', error);
    throw error;
  }
};

// ==================== REQUEST STATUS OPERATIONS ====================

/**
 * Get all request statuses
 */
export const getAllRequestStatuses = async () => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get('/request-status/fetchall');
    return response.data;
  } catch (error) {
    console.error('Error fetching request statuses:', error);
    throw error;
  }
};

/**
 * Create a new request status
 * @param {Object} requestStatusData
 */
export const createRequestStatus = async (requestStatusData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/request-status/create', requestStatusData);
    return response.data;
  } catch (error) {
    console.error('Error creating request status:', error);
    throw error;
  }
};

/**
 * Get request statuses by tenant ID
 * @param {string} tenantId
 */
export const getRequestStatusesByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/request-status/by-tenant/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching request statuses by tenant ID:', error);
    throw error;
  }
};

/**
 * Get a request status by its ID
 * @param {string} id
 */
export const getRequestStatusById = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/request-status/fetch/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching request status by ID:', error);
    throw error;
  }
};

/**
 * Update a request status by ID
 * @param {string} id
 * @param {Object} requestStatusData
 */
export const updateRequestStatus = async (id, requestStatusData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/request-status/update/${id}`, requestStatusData);
    return response.data;
  } catch (error) {
    console.error('Error updating request status:', error);
    throw error;
  }
};

/**
 * Send the current request status to the user who created the request.
 * @param {string} id
 */
export const notifyRequestStatusCreator = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post(`/request-status/notify/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error sending request status notification:', error);
    throw error;
  }
};

/**
 * Delete a request status by ID
 * @param {string} id
 */
export const deleteRequestStatus = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/request-status/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting request status:', error);
    throw error;
  }
};

// ==================== UTILITY OPERATIONS ====================

// Test Firestore connection for custom prompts
export const testCustomPromptsFirestoreConnection = async () => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get('/custom-prompts/health/firestore');
    return response.data;
  } catch (error) {
    console.error('Error testing Firestore connection:', error);
    throw error;
  }
};

// Test Firestore connection for segments
export const testSegmentsFirestoreConnection = async () => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get('/segment/test-firestore');
    return response.data;
  } catch (error) {
    console.error('Error testing Firestore connection:', error);
    throw error;
  }
};

//======================== ALERTS  ENDPOINTS =========================
// Create a new alert
export const createAlert = async (params) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/alerts/notify-user/', params);
    return response.data;
  } catch (error) {
    console.error('Error creating alert:', error);
    throw error;
  }
};

// Get alert by ID
export const getAlertById = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/alerts/fetch/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching alert with id ${id}:`, error);
    throw error;
  }
};

// Update alert by ID
export const updateAlertById = async (id, updatedData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/alerts/update/${id}`, updatedData);
    return response.data;
  } catch (error) {
    console.error(`Error updating alert with id ${id}:`, error);
    throw error;
  }
};

// Delete alert by ID
export const deleteAlertById = async (id) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/alerts/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting alert with id ${id}:`, error);
    throw error;
  }
};

// Get alerts by tenantId
export const getAlertsByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/alerts/by-tenant/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching alerts for tenant ${tenantId}:`, error);
    throw error;
  }
};

// Update alerts by tenantId (bulk update)
export const updateAlertsByTenantId = async (tenantId, updateData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.put(`/alerts/by-tenant-update/${tenantId}`, updateData);
    return response.data;
  } catch (error) {
    console.error(`Error updating alerts for tenant ${tenantId}:`, error);
    throw error;
  }
}

// Delete alert by tenant ID
export const deleteAlertByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/alerts/by-tenant-delete/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting alert with id ${tenantId}:`, error);
    throw error;
  }
};

export const fetchPaginatedAlertsByTenantId = async (tenantId, page = 1, pageSize = 10) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/alerts/by-tenant/${tenantId}/fetchall`, {
      params: { page, pageSize },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching alerts for tenantId ${tenantId}:`, error);
    throw error;
  }
};


// Test Firestore connection for request status
export const testRequestStatusFirestoreConnection = async () => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get('/request-status/test-firestore');
    return response.data;
  } catch (error) {
    console.error('Error testing Firestore connection:', error);
    throw error;
  }
};

// ==================== EMAIL ENDPOINTS ====================

export const sendEvaluationEmail = async (emailData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/email/evaluation', emailData);
    return response.data;
  } catch (error) {
    console.error('Error sending evaluation email:', error);
    throw error;
  }
};

export const sendGeneralEmail = async (emailData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/email/send', emailData);
    return response.data;
  } catch (error) {
    console.error('Error sending General email:', error);
    throw error;
  }
};

export const sendApprovalEmail = async (emailData) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/email/approval', emailData);
    return response.data;
  } catch (error) {
    console.error('Error sending approval email:', error);
    throw error;
  }
};

// ==================== PORTFOLIO SCORE RECORDS ENDPOINTS ====================

export const getPortfolioScoreRecords = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/portfolio-score-records/tenant/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching portfolio score records:', error);
    throw error;
  }
};

// ==================== ROLES ENDPOINTS ====================

// Get roles by tenant ID
export const getRolesByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/roles/by-tenant/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching roles by tenant ID:', error);
    throw error;
  }
};

// ==================== API KEY ENDPOINTS ====================

// Create a new API key
export const createApiKey = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/api-keys/create', { tenantId });
    return response.data;
  } catch (error) {
    console.error('Error creating API key:', error);
    throw error;
  }
};

// Get API key by tenant ID
export const getApiKeyByTenantId = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/api-keys/fetch/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching API key by tenant ID:', error);
    throw error;
  }
};

// Revoke API key
export const revokeApiKey = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/api-keys/revoke', { tenantId });
    return response.data;
  } catch (error) {
    console.error('Error revoking API key:', error);
    throw error;
  }
};

export const logRiskMitigationRequested = async (companyId, data) => {
  try {
    const apiClient = getApiClient('tenant');
    const response = await apiClient.post(`/company-logs/${companyId}/risk-mitigation-requested`, data);
    return response.data;
  } catch (error) {
    console.error('Error logging risk mitigation request:', error);
    throw error;
  }
}

export const logApproval = async (companyId, data) => {
  try {
    const apiClient = getApiClient('tenant');
    const response = await apiClient.post(`/company-logs/${companyId}/approval`, data);
    return response.data;
  } catch (error) {
    console.error('Error logging approval:', error);
    throw error;
  }
}

// ==================== PRODUCT ANALYTICS ====================

// Admin reads for the Product Analytics console. `params` accepts { days|from|to,
// tenantId, includeAdmins }. Errors bubble so the console can show a retry state.
export const getAnalyticsOverview = async (params = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/analytics/overview', { params });
  return response.data?.data;
};

export const getAnalyticsFunnel = async (params = {}) => {
  const apiClient = getApiClient('tenant');
  const q = { ...params };
  if (q.steps && typeof q.steps !== 'string') q.steps = JSON.stringify(q.steps);
  const response = await apiClient.get('/analytics/funnel', { params: q });
  return response.data?.data;
};

export const getAnalyticsUsers = async (params = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/analytics/users', { params });
  return response.data?.data;
};

export const getAnalyticsUserJourney = async (userId, params = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/analytics/users/${encodeURIComponent(userId)}/journey`, { params });
  return response.data?.data;
};

export const getAnalyticsTenants = async (params = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/analytics/tenants', { params });
  return response.data?.data;
};

export const getAnalyticsTenantFeatures = async (tenantId, params = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/analytics/tenants/${encodeURIComponent(tenantId)}/features`, { params });
  return response.data?.data;
};

export const getTenantUsageHealth = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/usage-health/tenants/${encodeURIComponent(tenantId)}`);
  return response.data?.data;
};

// ==================== GROUPED EXPORTS ====================

// Tenant service
const tenantService = {
  getAllTenants,
  createTenant,
  getTenantById,
  updateTenant,
  deleteTenant,
};

// Dashboard preferences service
const dashboardPreferencesService = {
  createDashboardPreferences,
  getPreferencesByTenantId,
  updatePreferences,
  deletePreferences,
  getPreferencesByTenantIdAndFeature,
  deleteDashboardPreferencesByTenantId,
  updateDashboardPreferencesByTenantIdAndFeature 
};

// User preferences service
const userPreferencesService = {
  createUserPreferences,
  getUserPreferencesByUserId,
  getUserPreferencesByUserIdAndFeature,
  updateUserPreferencesByUserIdAndFeature,
  deleteUserPreferencesByUserId
};

// Custom prompts service
const customPromptService = {
  createCustomPrompt,
  getCustomPromptByTenantId,
  updateCustomPromptById,
  deleteCustomPromptByTenantId,
  deleteCustomPromptsByTenantAndSegment,
  deleteAllCustomPromptsByTenant,
  testCustomPromptsFirestoreConnection,
  updateCustomPromptByTenantAndSegment,
  updateAllCustomPromptsByTenant
};

// Segment service
const segmentService = {
  createSegment,
  getAllSegments,
  getSegmentsByTenantId,
  updateSegmentsByTenantId,
  deleteSegmentsByTenantId,
  getSegmentById,
  updateSegment,
  deleteSegment,
  testSegmentsFirestoreConnection,
};

// Request status service
const requestStatusService = {
  getAllRequestStatuses,
  createRequestStatus,
  getRequestStatusesByTenantId,
  getRequestStatusById,
  updateRequestStatus,
  notifyRequestStatusCreator,
  deleteRequestStatus,
  testRequestStatusFirestoreConnection,
};

//Alerts service
const alertService = {
  createAlert,
  getAlertById,
  updateAlertById,
  deleteAlertById,
  getAlertsByTenantId,
  updateAlertsByTenantId,
  deleteAlertByTenantId,
  fetchPaginatedAlertsByTenantId
};

// Create Auth0 user via backend
export const createAuth0User = async (userPayload) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/auth0/create-user', userPayload);
  return response.data;
};

// Get user metadata (isAdmin, tenantId) from backend proxy
export const getUserMetadataBySubId = async (subId) => {
  if (!subId) throw new Error('subId is required');
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/auth0/user-metadata', { params: { subId } });
  return response.data;
};
// Get user metadata (isAdmin, tenantId) from backend proxy
export const getUserInfoBySubId = async (subId) => {
  if (!subId) throw new Error('subId is required');
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/auth0/get-user`,{params:{subId}});
  return response.data;
};

export const updateAuth0User = async (subId, updatePayload) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.patch(`/auth0/update-user/${encodeURIComponent(subId)}`, updatePayload);
  return response.data;
};

// Persist the complete first-login questionnaire in the tenant database.
// Tenant and user identity are derived by the backend from the access token.
export const saveOnboardingProfile = async (profile, adminTenantId = null) => {
  const apiClient = getApiClient('tenant');
  const path = adminTenantId
    ? `/onboarding/profile/${encodeURIComponent(adminTenantId)}`
    : '/onboarding/profile';
  const response = await apiClient.put(path, profile);
  return response.data;
};

export const getOnboardingProfile = async (adminTenantId = null) => {
  const apiClient = getApiClient('tenant');
  const path = adminTenantId
    ? `/onboarding/profile/${encodeURIComponent(adminTenantId)}`
    : '/onboarding/profile';
  const response = await apiClient.get(path);
  return response.data;
};

// ==================== TENANT USER MANAGEMENT (admin) ====================

// List all users of a tenant (enriched with live Auth0 status)
export const getUsersByTenant = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/auth0/users-by-tenant/${encodeURIComponent(tenantId)}`);
  return response.data; // { success, data: [...] }
};

// Resolve the selected user's tenant membership and role for an admin's
// read-only "View as user" support preview.
export const getSupportPreview = async (tenantId, userId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(
    `/auth0/support-preview/${encodeURIComponent(tenantId)}/${encodeURIComponent(userId)}`
  );
  return response.data;
};

// Search-relevant user names/emails grouped by tenant (Platform Console admins only).
export const getTenantUserDirectory = async () => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/auth0/tenant-user-directory');
  return response.data;
};

// Most-recent login across each tenant's users → { [tenantId]: lastLoginISO }
export const getTenantsLastLogin = async () => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/auth0/tenants-last-login');
  return response.data; // { success, data: { tenantId: iso } }
};

// Block / unblock a user
export const setUserBlocked = async (subId, blocked) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post(`/auth0/set-blocked/${encodeURIComponent(subId)}`, { blocked });
  return response.data;
};

// Send a "set your password" / activation email (delivered via Resend)
export const sendPasswordReset = async (email, opts = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/auth0/reset-password', { email, name: opts.name, tenantName: opts.tenantName });
  return response.data;
};

// Replace an Auth0 database user's password and return the new value once.
export const setTemporaryUserPassword = async (subId, tenantId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post(`/auth0/set-temporary-password/${encodeURIComponent(subId)}`, { tenantId });
  return response.data;
};

// Resend the email-verification message
export const resendVerificationEmail = async (subId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post(`/auth0/resend-verification/${encodeURIComponent(subId)}`, {});
  return response.data;
};

// Delete a user (Auth0 + Firestore + tenant emailList)
export const deleteAuth0User = async (subId, { tenantId, email } = {}) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.delete(`/auth0/delete-user/${encodeURIComponent(subId)}`, {
    params: { tenantId, email },
  });
  return response.data;
};

// ==================== CARRIER / SURETY ONBOARDING ADMIN ====================

export const getCarrierOnboardingDirectory = async () => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get('/carrier-onboarding/directory');
  return response.data;
};

export const getCarrierOnboardingFile = async (submissionId) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.get(`/carrier-onboarding/onboarding-files/${encodeURIComponent(submissionId)}`);
  return response.data;
};

export const sendCarrierOnboardingInvitation = async (payload) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/carrier-onboarding/invitations', payload);
  return response.data;
};

export const manageCarrierOnboardingInvitation = async (inviteId, action) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post(`/carrier-onboarding/invitations/${encodeURIComponent(inviteId)}/${encodeURIComponent(action)}`);
  return response.data;
};

export const inviteCarrierPlatformUser = async (payload) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/carrier-onboarding/users/invite', payload);
  return response.data;
};

export const resetCarrierPlatformPassword = async (companyId, email) => {
  const apiClient = getApiClient('tenant');
  const response = await apiClient.post('/carrier-onboarding/users/reset-password', { companyId, email });
  return response.data;
};


// ==================== FINANCIAL REPORT PROMPTS OPERATIONS ====================

export const getFinancialReportPrompt = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.get(`/financial-report-prompts/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching financial report prompt by tenant ID:', error);
    throw error;
  }
};

export const saveFinancialReportPrompt = async (tenantId, prompt) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.post('/financial-report-prompts', { tenantId, prompt });
    return response.data;
  } catch (error) {
    console.error('Error saving financial report prompt:', error);
    throw error;
  }
};

export const deleteFinancialReportPrompt = async (tenantId) => {
  const apiClient = getApiClient('tenant');
  try {
    const response = await apiClient.delete(`/financial-report-prompts/${tenantId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting financial report prompt by tenant ID:', error);
    throw error;
  }
};

export default {
  ...tenantService,
  ...dashboardPreferencesService,
  ...userPreferencesService,
  ...customPromptService,
  ...segmentService,
  ...requestStatusService,
  ...alertService,
  sendEvaluationEmail,
  sendGeneralEmail,
  sendApprovalEmail,
  getPortfolioScoreRecords,
  getUserMetadataBySubId,
  getUserInfoBySubId,
  createAuth0User,
  updateAuth0User,
  getUsersByTenant,
  setUserBlocked,
  sendPasswordReset,
  resendVerificationEmail,
  deleteAuth0User,
  getRolesByTenantId,
  createApiKey,
  getApiKeyByTenantId,
  revokeApiKey,
  getFinancialReportPrompt,
  saveFinancialReportPrompt,
  deleteFinancialReportPrompt
};
